module.exports = __webpack_public_path__ + "img/get-coupon-btn-bf.eda628ca.png";